import { Directive, HostListener, Input } from '@angular/core';
import { GtagService } from 'src/app/core/service/gtag.service';

/**
 * Fires a per-tenant gtag custom event when the host element is clicked.
 *
 * Usage:
 *   <button (click)="onApply()" appGtagEvent="apply_top">Apply</button>
 *   <a routerLink="/programs" appGtagEvent="nav_programs">Programs</a>
 *
 * Design notes:
 *   - Listens to `click` only — does NOT call preventDefault / stopPropagation,
 *     so any existing (click)= handler on the same element fires normally.
 *   - GtagService.trackEvent() is itself a safe no-op when the tenant has not
 *     configured `google_analytics_events`, so adding this directive to a
 *     button on a tenant that doesn't opt in costs nothing.
 *   - Missing / empty event key → silent no-op (won't throw or log noise).
 *
 * Use `module.action` naming when adding new keys (e.g. `programs.apply_top`,
 * `meetings.book_slot`) to keep the per-tenant config organized as the event
 * catalogue grows.
 */
@Directive({
  selector: '[appGtagEvent]'
})
export class GtagEventDirective {
  @Input('appGtagEvent') eventKey: string | undefined;

  constructor(private gtagService: GtagService) {}

  @HostListener('click') onClick(): void {
    const key = (this.eventKey || '').toString().trim();
    if (!key) return;
    this.gtagService.trackEvent(key);
  }
}
